import React, { Component } from 'react';
import styled from 'styled-components';
import onClickOutside from "react-onclickoutside";

import css from 'css';
import SmartLink from 'partials/SmartLink';
import SocialLinks from 'partials/SocialLinks';

class Menu extends Component {
    
    constructor(props) {
        super(props);
        
        this.focused = false;
    }
  
    render() {
        const { menuVisible, primaryMenu, secondaryMenu, onMenuLinkClick, pageBackground, headerColor, onChamburgerClick } = this.props;
        return (
            <NavWrapper ref="wrapper">

                <MenuButton
                    className={[menuVisible ? 'open' : ''].join(' ')} 
                    onFocus={e => {
                        onChamburgerClick();
                        this.focused = true;
                    }}
                    onClick={e => {
                        if(!this.focused) onChamburgerClick();
                        this.focused = false;  
                    }} 
                    pageBackground={pageBackground} headerColor={headerColor} 
                >
                    <div className="label">{menuVisible ? 'Lukk' : 'Meny'}</div>
                    <Chamburger className={[menuVisible ? 'open' : ''].join(' ')} >
                        <span />
                    </Chamburger>
                </MenuButton>

                <MenuWrapper visisble={menuVisible}>
                    <nav>
                        <div className="menus">
                            <ul className="primary">
                                {primaryMenu && primaryMenu.map(item => {
                                    return(
                                        <li key={item.id}>
                                            <SmartLink to={item.url} onClick={e => onMenuLinkClick(item, e)}>{item.title}</SmartLink>
                                        </li> 
                                    );
                                })}
                            </ul>
                            <ul className="secondary">
                                {secondaryMenu && secondaryMenu.map(item => {
                                    return(
                                        <li key={item.id}>
                                            <SmartLink to={item.url} onClick={e => onMenuLinkClick(item, e)}>{item.title}</SmartLink>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                        <SocialLinks color="#fff" onLastLinkBlur={() => onChamburgerClick()} />
                    </nav>
                </MenuWrapper>

            </NavWrapper>
        );
    }
}

export default onClickOutside(Menu);

const NavWrapper = styled.div`
`

const MenuButton = styled.button`
    display: flex;
    align-items:center;
    right:0;
    position: relative;

    .label {
        color: ${css.colors.darkBlue};
        cursor: pointer;
        ${props => props.pageBackground === 'main' || props.headerColor === 'white' ? `
            color: #fff;
        ` : ``}
    }
    &.open .label {
        color: #fff;
        z-index: 10;
    }

    transition: all .3s ease-in-out;
    &.open {
        position:fixed;
        right: 30px;
        z-index: 200;
        top:38px;
        @media(max-width: 767px) {
            right: 10px;
            top:20px;
        }
    }
`

const Chamburger = styled.div`
    height: 56px;
    width: 56px;
    background: ${css.colors.darkBlue};
    z-index:101;
    display: block;
    position:relative;
    border-radius: 56px;
    margin-left:18px;
    cursor: pointer;
    @media(max-width: 767px) {
        height: 46px;
        width: 46px;
    }
    span, &:before, &:after, span:after {
        content: '';
        width:24px;
        height:3px;
        background: #fff;
        border-radius: 1.5px;
        position:absolute;
        top: 50%;
        left: 50%;
        transform: translateY(-1px) translateX(-50%);
        display:block;
        transition: all .1s ease-in-out;
        transform-origin: 50% 50%;
    }
    span { }
    span:after { opacity:0; }
    &:before { transform: translateY(-11px) translateX(-50%); }
    &:after { transform: translateY(9px) translateX(-50%);  }
    &.open {
        margin-left: 0;
        &:before { opacity: 0; transform: translateY(-16px) translateX(-50%); }
        &:after { opacity: 0; transform: translateY(14px) translateX(-50%); }
        span {
            transform: translateY(-1px) translateX(-50%) rotate(45deg);
            &:after {
                transform: translateY(-1px) translateX(-50%) rotate(-90deg);
                opacity:1;
            }
        }
    }
`

const MenuWrapper = styled.div`
    position: fixed;
    top:0;
    right:0;
    width: 458px;
    max-width: 80%;
    height:100vh;
    background: ${css.colors.darkBlue};
    transform: translateX(100%);
    padding-top:115px;
    padding-bottom:30px;
    @media(max-width: 767px) {
        padding-top:68px;
        padding-bottom:20px;
    }

    ${props => props.visisble === true ? `
        animation-name: slideIn;
        animation-duration: .5s;
        animation-fill-mode: forwards;
        animation-timing-function: ease-in-out;
    ` : ``}

    ${props => props.visisble === false ? `
        animation-name: slideOut;
        animation-duration: .5s;
        animation-fill-mode: forwards;
        animation-timing-function: ease-in-out;
    ` : ``}

    @keyframes slideIn {
        50% { transform: translateX(0); }
        100% { transform: translateX(20px); }
    }

    @keyframes slideOut {
        0% { transform: translateX(20px); }
        50% { transform: translateX(0%); }
        100% { transform: translateX(100%); }
    }

    nav  { 
        color: #fff;
        height:100%;
        display:flex;
        flex-direction: column;
        justify-content: space-between;
        overflow-y:auto;

        .menus {
            ul.primary {
                margin-bottom:30px;
                margin-top:1px;
                @media(max-width: 767px) {
                    margin-bottom: 20px;
                }
                li {
                    a {
                        font-size:24px;
                        display: block;
                        padding: 10px 30px 10px 32px;
                        border-left: 8px solid transparent;
                        transition:all .2s ease-in-out;
                        @media(max-width: 767px) {
                            font-size: 18px;
                            padding: 8px 30px 8px 22px;
                        }
                        &:hover, &.active, &:focus {
                            background: rgba(0,0,0,.2);
                            border-left: 8px solid ${css.colors.red};
                        }
                    }
                }
            }
            ul.secondary {
                margin-bottom:30px;
                @media(max-width: 767px) {
                    margin-bottom: 20px;
                }
                li {
                    a {
                        font-size:18px;
                        display: block;
                        padding: 6px 26px 6px 32px;
                        border-left: 8px solid transparent;
                        transition:all .2s ease-in-out;
                        @media(max-width: 767px) {
                            font-size: 16px;
                            padding: 6px 26px 6px 22px;
                        }
                        &:hover, &.active, &:focus {
                            background: rgba(0,0,0,.2);
                            border-left: 8px solid ${css.colors.red};
                        }
                    }
                }
            }
        }
    }

    .social-links {
        margin-bottom:1px;
        li {
            a {
                font-size:18px;
                padding: 10px 30px 10px 32px;
                border-left: 8px solid transparent;
                &:hover, &:focus {
                    background: rgba(0,0,0,.2);
                    border-left: 8px solid ${css.colors.red};
                }
                @media(max-width: 767px) {
                    font-size: 16px;
                    padding: 6px 26px 6px 22px;
                }
            }
        }
    }
`


// WEBPACK FOOTER //
// ./src/partials/Menu.js